import { Avatar, Tooltip } from "@material-tailwind/react";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import client from "../client/Client";

interface speakerContent {
  Role: string;
  image: {
    asset: {
      _ref: string;
    };
  };
  Biography: BioType[];
  linkedinUrl: string;
  name: string;
  profileUrl: string;
  university: string;
}

interface BioType {
  children: Array<{
    text: string;
  }>;
}

export default function FeaturesBlocks() {
  const [speakers, setSpeakers] = useState<speakerContent[]>([]);

  useEffect(() => {
    client
      .fetch('*[_type == "SpeakerPage"]')
      .then((result) => {
        setSpeakers(result[0].SpeakerPage);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, []);

  return (
    <section className="relative bg-transparent">
      <div className="relative max-w-6xl mx-auto px-4 sm:px-6">
        <div className="py-12 md:py-20">
          {/* Header section - Mobile responsive */}
          <div className="max-w-3xl mx-auto text-center pb-8 md:pb-20 px-4">
            <h2 className="text-2xl sm:text-2xl font-bold text-blue-901 mb-4">
              Speakers
            </h2>

            <p className="text-base sm:text-lg md:text-xl text-gray-600 leading-relaxed">
              The SSD conference brings together leading experts and researchers in the field of Electrical Engineering and Information Technology.
              Renowned keynote speakers share their expertise, while oral sessions provide a platform for knowledge exchange.
            </p>
          </div>

          {/* Speakers grid - Responsive layout */}
          <div className="max-w-xs mx-auto grid gap-6 sm:max-w-sm sm:grid-cols-2 lg:grid-cols-3 items-start md:max-w-2xl lg:max-w-none">
            {speakers.length > 0 &&
              speakers.slice(0, 3).map((speaker, index) => (
                <div
                  key={index}
                  className="relative flex flex-col items-center p-4 sm:p-6 bg-white rounded shadow-xl hover:shadow-2xl transition-shadow duration-200"
                >
                  {/* Tooltip for biography */}
                  <Tooltip
                    interactive={true}
                    content={
                      <div className="max-w-xs sm:max-w-sm md:max-w-xl max-h-32 sm:max-h-44 overflow-y-auto p-2">
                        <h1 className="text-red-400 text-lg sm:text-xl font-semibold mb-2">
                          {speaker.name}
                        </h1>

                        {speaker?.Biography?.length > 0 ? (
                          speaker.Biography.map((bio, bioIndex) => (
                            <p
                              key={bioIndex}
                              className="text-sm sm:text-base text-gray-700 mb-1"
                            >
                              - {bio.children[0].text}
                            </p>
                          ))
                        ) : (
                          <h1 className="text-gray-600 text-sm sm:text-base">
                            There is no Bio for this person
                          </h1>
                        )}
                      </div>
                    }
                    className="cursor-pointer"
                  >
                    {/* Info icon */}
                    <span className="absolute z-10 w-6 h-6 sm:w-8 sm:h-8 rounded-full bg-white m-4 sm:m-6 right-0 top-0 flex items-center justify-center shadow-sm">
                      <svg
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className="w-4 h-4 sm:w-5 sm:h-5"
                      >
                        <circle
                          opacity="0.5"
                          cx="12"
                          cy="12"
                          r="10"
                          stroke="#ff0000"
                          strokeWidth="1.5"
                        />
                        <path
                          d="M12 17V11"
                          stroke="#ff0000"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                        />
                        <circle
                          cx="1"
                          cy="1"
                          r="1"
                          transform="matrix(1 0 0 -1 11 9)"
                          fill="#ff0000"
                        />
                      </svg>
                    </span>
                  </Tooltip>

                  {/* Speaker avatar */}
                  <Avatar
                    src={`https://cdn.sanity.io/images/79vgbaej/production/${
                      speaker.image?.asset._ref.slice(6, -4) +
                      "." +
                      speaker.image?.asset._ref.slice(-3)
                    }`}
                    alt={`${speaker.name} avatar`}
                    withBorder={true}
                    size="xl"
                    className="p-0.5 m-2 w-20 h-20 sm:w-24 sm:h-24"
                  />

                  {/* Speaker name */}
                  <h4 className="text-base sm:text-lg font-bold leading-snug tracking-tight mb-1 text-center">
                    {speaker.name}
                  </h4>

                  {/* Speaker role */}
                  <p className="text-gray-600 text-center text-sm sm:text-base leading-tight">
                    {speaker.Role}
                  </p>
                </div>
              ))}
          </div>

          {/* See all speakers button - Centered on mobile */}
          <div className="mt-6 w-full flex flex-row justify-center sm:justify-end">
            <Link
              to="/speakers"
              className="btn-sm text-white bg-red-600 hover:bg-red-700 ml-0 sm:ml-3 px-4 py-2 rounded-lg transition-colors duration-200 flex items-center justify-center"
            >
              <span className="text-sm sm:text-base">See all Speakers</span>

              <svg
                className="w-3 h-3 fill-current text-white shrink-0 ml-2 -mr-1"
                viewBox="0 0 12 12"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11.707 5.293L7 .586 5.586 2l3 3H0v2h8.586l-3 3L7 11.414l4.707-4.707a1 1 0 000-1.414z"
                  fillRule="nonzero"
                />
              </svg>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}